import { render, staticRenderFns } from "./EditCallbotDialog.vue?vue&type=template&id=604d636b&scoped=true"
import script from "./EditCallbotDialog.vue?vue&type=script&lang=ts"
export * from "./EditCallbotDialog.vue?vue&type=script&lang=ts"
import style0 from "./EditCallbotDialog.vue?vue&type=style&index=0&id=604d636b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604d636b",
  null
  
)

export default component.exports